import { createAsyncStoragePersister } from '@tanstack/query-async-storage-persister'
import { del, get, set } from 'idb-keyval'

const idbStorage = {
  getItem: async (k: string) => (await get<string>(k)) ?? null,
  setItem: async (k: string, v: string) => set(k, v),
  removeItem: async (k: string) => del(k),
}

export const queryPersister = createAsyncStoragePersister({
  storage: idbStorage,
  key: 'mysterra-rq-cache',
  throttleTime: 1000,
})
